/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { useDidMount } from '@mtsbank/ui-kit';
import { OldHeader } from '@widgets/header';
import { useSetBreadCrumbsCurrentPath } from '@shared/lib/breadcrumbs';
import { withTheme } from '@shared/lib';
import { newYearGiveawayLoadedCyberGtm } from '@shared/lib/gtm';
import HeroSectionView from './HeroSectionView';
import WinnerDeterminationSectionView from './WinnerDeterminationSectionView';
import ParticipationRulesSectionView from './ParticipationRulesSectionView';
import ReplenishSteamSectionView from './ReplenishSteamSectionView';
import FAQSectionView from './FAQSectionView';
import SnowfallAnimation from './SnowfallAnimation';
const NewYearGiveawayPageView: FC = () => {
  useSetBreadCrumbsCurrentPath('Новогодний розыгрыш Steam');
  useDidMount(() => {
    newYearGiveawayLoadedCyberGtm();
  });
  return <NewYearGiveawayPageViewWrapper>
      <HeaderWrapper>
        <OldHeader />
      </HeaderWrapper>
      <HeroSectionView />
      <WinnerDeterminationSectionView />
      <ParticipationRulesSectionView />
      <ReplenishSteamSectionView />
      <FAQSectionView />
      <div style={{
      scrollSnapAlign: 'start',
      height: '0.01px'
    }} />
      <SnowfallAnimation />
    </NewYearGiveawayPageViewWrapper>;
};
export default NewYearGiveawayPageView;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const NewYearGiveawayPageViewWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "NewYearGiveawayPageViewWrapper",
  class: "nnx90lx",
  propsAsIs: false,
  vars: {
    "nnx90lx-0": [_exp()]
  }
}));
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hwn8s0g",
  propsAsIs: false
});

require("./NewYearGiveawayPageView.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NewYearGiveawayPageView.tsx");